import API from "..";
import {
  API_GET_PAGE_TENKEN_TOP,
  API_GET_MASTER_TOP,
  //API_GET_MACHINE_INPUT_PAGE,
  API_GET_DEPARTMENT_UPDATE_HISTORY_SEARCH_PAGE,
  API_GET_DEPARTMENT_MASTER_IMPORT_PAGE,
  API_GET_DEPARTMENT_MASTER_EXPORT_PAGE,
  API_GET_MACHINE_TOP,
  API_MACHINE_UPDATE_SIDEBAR,
  API_MACHINE_HISTORY_SEARCH_SIDEBAR,
  API_MACHINE_IMPORT_SIDEBAR,
  API_MACHINE_EXPORT_SIDEBAR,
  API_GET_DEPARTMENT_TOP,
  API_GET_POSITION_TOP,
  API_POSITION_UPDATE_SIDEBAR,
  API_POSITION_HISTORY_SEARCH_SIDEBAR,
  API_POSITION_IMPORT_SIDEBAR,
  API_POSITION_EXPORT_SIDEBAR,
  API_GET_MACHINE_INPUT_SETTING,
  API_CHANGE_PASSWORD_SIDEBAR,
  API_GET_SETTING_PAGE,
  API_GET_UNFINISHED_SETTING,
  API_GET_REGISTER_INSPECTION_SETTING,
  API_GET_TEMPLATE_MANAGEMENT_SETTINGS,
  API_GET_INSPECTION_ITEM_SETTINGS,
  API_GET_UPDATE_INSPECTION_SETTING,
  API_GET_JUDGMENT_PAGE,
  API_GET_REGISTER_TREATMENT_SETTING,
  API_GET_SEARCH_SIDEBAR,
  API_GET_SEARCH_INSPECTION_SETTING,
  API_GET_SEARCH_MACHINE_SIDEBAR,
  API_GET_INSPECTION_SHEET_SETTING
} from "../../constants/api";

import * as apis from "../../constants/api";
import { errorStatusHandle } from "../../utils";
import { DASHBOARD } from "../../constants/routes";

// Function help get page setting from api url
const getPageSettings = async (apiUrl, params) => {
  localStorage.setItem("backUrl", DASHBOARD);
  try {
    const response = await API.get(apiUrl, { params: params });
    const responseData = response.data;
    if (responseData.success === true) {
      return responseData.data;
    }
    return Promise.reject("Can not get page settings");
  } catch (error) {
    errorStatusHandle(error.response);
    return Promise.reject(error);
  }
};

//Function help to get page tenken top settings
const getTenkenTopPageSettings = () => {
  return getPageSettings(API_GET_PAGE_TENKEN_TOP);
};

// Function help to get machine top page
const getMachineTopPageSettings = () => {
  return getPageSettings(API_GET_MACHINE_TOP);
};

const getMachineUpdatePageSettings = () => {
  return getPageSettings(API_MACHINE_UPDATE_SIDEBAR);
};

const getMachineHistorySearchPageSettings = () => {
  return getPageSettings(API_MACHINE_HISTORY_SEARCH_SIDEBAR);
};

const getMachineImportPageSettings = () => {
  return getPageSettings(API_MACHINE_IMPORT_SIDEBAR);
};

const getMachineExportPageSettings = () => {
  return getPageSettings(API_MACHINE_EXPORT_SIDEBAR);
};

// Function help to get position top page
const getPositionTopPageSettings = () => {
  return getPageSettings(API_GET_POSITION_TOP);
};

const getPositionUpdatePageSettings = () => {
  return getPageSettings(API_POSITION_UPDATE_SIDEBAR);
};

const getPositionHistorySearchPageSettings = () => {
  return getPageSettings(API_POSITION_HISTORY_SEARCH_SIDEBAR);
};

const getPositionImportPageSettings = () => {
  return getPageSettings(API_POSITION_IMPORT_SIDEBAR);
};

const getPositionExportPageSettings = () => {
  return getPageSettings(API_POSITION_EXPORT_SIDEBAR);
};

// Function help to get approva settings master page
const getApprovalSettingTopPage = () => {
  return getPageSettings(apis.API_APPROVAL_SETTING_TOP);
};

const getWorkflowPageSetting = (page) => {
  return getPageSettings(apis.API_GET_WORKFLOW_SETTING + `/${page}`);
};

const getApprovalSettingSearchPageSettings = () => {
  return getPageSettings(apis.API_APPROVAL_SETTING_SEARCH_PAGE);
};

const getApprovalSettingImportPage = () => {
  return getPageSettings(apis.API_APPROVAL_SETTING_IMPORT_PAGE);
};

const getApprovalSettingExportPage = () => {
  return getPageSettings(apis.API_APPROVAL_SETTING_EXPORT_PAGE);
};

// Function help to get inspection templates master page
const getInspectionTemplateTopPage = () => {
  return getPageSettings(apis.API_INSPECTION_TEMPLATE_TOP);
};

// Function help to get template-management page
const getTemplateManagementPageSettings = () => {
  return getPageSettings(API_GET_TEMPLATE_MANAGEMENT_SETTINGS);
};

// Function help to get edit-inspection page
const getEditInspectionItemPageSettings = () => {
  return getPageSettings(API_GET_INSPECTION_ITEM_SETTINGS);
};

const getInspectionTemplateSearchPage = () => {
  return getPageSettings(apis.API_INSPECTION_TEMPLATE_SEARCH_PAGE);
};

const getInspectionTemplateImportPage = () => {
  return getPageSettings(apis.API_INSPECTION_TEMPLATE_IMPORT_PAGE);
};

const getInspectionTemplateExportPage = () => {
  return getPageSettings(apis.API_INSPECTION_TEMPLATE_EXPORT_PAGE);
};

const getUserInTemplates = async (templates) => {
  const headers = {
    "Content-Type": "application/json; charset=UTF-8",
  };
  const data = { templates: templates };
  const response = await API.get(
    apis.API_GET_USER_IN_TEMPLATES,
    {
      params: data,
    },
    {
      headers: headers,
    }
  );
  return response;
};

const getDepartmentPageSetting = (params) => {
  return getPageSettings(apis.API_GET_DEPARTMENT_SETTING, params);
};

export const getMyPageSetting = (params) => {
  return getPageSettings(apis.API_MY_PAGE_SETTING, params);
};

const getMachineGroupSetting = () => {
  return getPageSettings(apis.API_GET_MACHINE_GROUP_SETTING);
};

// Function help to get department top page
const getDepartmentTopPageSettings = () => {
  return getPageSettings(API_GET_DEPARTMENT_TOP);
};
// Function help to get master top page
const getMasterTopPageSettings = () => {
  return getPageSettings(API_GET_MASTER_TOP);
};

// Function help to get position top page
const getDepartmentMasterUpdateHistorySearchPageSettings = () => {
  return getPageSettings(API_GET_DEPARTMENT_UPDATE_HISTORY_SEARCH_PAGE);
};

const getDepartmentMasterImportPageSettings = () => {
  return getPageSettings(API_GET_DEPARTMENT_MASTER_IMPORT_PAGE);
};

const getDepartmentMasterExportPageSettings = () => {
  return getPageSettings(API_GET_DEPARTMENT_MASTER_EXPORT_PAGE);
};

const getMachineInputPageSettings = () => {
  return getPageSettings(API_GET_MACHINE_INPUT_SETTING);
};

const getChangePasswordPageSettings = () => {
  return getPageSettings(API_CHANGE_PASSWORD_SIDEBAR);
};

// Function help to get position top page
const getSettingPageSettings = () => {
  return getPageSettings(API_GET_SETTING_PAGE);
};

// Function help to get position top page
const getJudgmentPageSetting = () => {
  return getPageSettings(API_GET_JUDGMENT_PAGE);
};

// Function help to get position top page
export const getInspectionStatusPageSetting = () => {
  return getPageSettings(apis.API_GET_INSPECTION_STATUS_PAGE_SETTING);
};

// Function help to get unfinished page
const getUnfinishedPageSettings = () => {
  return getPageSettings(API_GET_UNFINISHED_SETTING);
};

const getRegisterInspectionPageSettings = () => {
  return getPageSettings(API_GET_REGISTER_INSPECTION_SETTING);
};

const getUpdateInspectionPageSettings = () => {
  return getPageSettings(API_GET_UPDATE_INSPECTION_SETTING);
};

const getRegisterTreatmentPageSettings = () => {
  return getPageSettings(API_GET_REGISTER_TREATMENT_SETTING);
};

// Function help to get search page
const getSearchPageSettings = () => {
  return getPageSettings(API_GET_SEARCH_SIDEBAR);
};
const getSearchMachinesPageSettings = () => {
  return getPageSettings(API_GET_SEARCH_MACHINE_SIDEBAR);
};

// Function help to get SearchInspectionHistoryResult page
const getSearchInspectionHistoryResultSettings = () => {
  return getPageSettings(API_GET_SEARCH_INSPECTION_SETTING);
};

// Function help to get SearchInspectionHistoryResult page
const getInspectionSheetPageSetting = () => {
  return getPageSettings(API_GET_INSPECTION_SHEET_SETTING);
};

export {
  getTenkenTopPageSettings,
  getMasterTopPageSettings,
  getMachineTopPageSettings,
  getMachineUpdatePageSettings,
  getMachineHistorySearchPageSettings,
  getMachineImportPageSettings,
  getMachineExportPageSettings,
  getMachineGroupSetting,
  getPositionTopPageSettings,
  getPositionUpdatePageSettings,
  getPositionHistorySearchPageSettings,
  getPositionImportPageSettings,
  getPositionExportPageSettings,
  getApprovalSettingTopPage,
  getWorkflowPageSetting,
  getApprovalSettingSearchPageSettings,
  getApprovalSettingImportPage,
  getApprovalSettingExportPage,
  getInspectionTemplateTopPage,
  getInspectionTemplateSearchPage,
  getInspectionTemplateImportPage,
  getInspectionTemplateExportPage,
  getDepartmentTopPageSettings,
  getDepartmentPageSetting,
  getDepartmentMasterUpdateHistorySearchPageSettings,
  getDepartmentMasterImportPageSettings,
  getDepartmentMasterExportPageSettings,
  getMachineInputPageSettings,
  getChangePasswordPageSettings,
  getSettingPageSettings,
  getUnfinishedPageSettings,
  getRegisterInspectionPageSettings,
  getTemplateManagementPageSettings,
  getEditInspectionItemPageSettings,
  getUpdateInspectionPageSettings,
  getJudgmentPageSetting,
  getRegisterTreatmentPageSettings,
  getSearchPageSettings,
  getSearchInspectionHistoryResultSettings,
  getSearchMachinesPageSettings,
  getUserInTemplates,
  getInspectionSheetPageSetting
};
